/**
 * Свёрнутость бокового меню между сеансами.
 *
 * Вынесено из самой раскладки (`app/layout/AppLayout.tsx`) по границе предмета: раскладка отвечает
 * на «что и где на экране», а здесь — работа с браузерным хранилищем, у которой свои правила и своя
 * причина существовать. Смешанные в одном файле, они и росли вместе, а ратчет качества
 * (`scripts/quality.mjs`) считает строки именно у раскладки.
 *
 * `localStorage` недоступен в приватном режиме части браузеров, и обе функции молча это переживают:
 * состояние меню — не данные пользователя, и падать из-за него нельзя. Цена — свёрнутое меню
 * развернётся после перезагрузки; на этом всё.
 */

const COLLAPSED_STORAGE_KEY = 'technic:sider-collapsed';

/** Свёрнуто ли меню в прошлый раз. Хранилище недоступно — считаем, что развёрнуто. */
export function readSiderCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSED_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Запомнить выбор. Отказ хранилища не ошибка: состояние просто не переживёт перезагрузку. */
export function writeSiderCollapsed(value: boolean): void {
  try {
    localStorage.setItem(COLLAPSED_STORAGE_KEY, value ? '1' : '0');
  } catch {
    /* состояние просто не переживёт перезагрузку */
  }
}
